export default __webpack_public_path__ + "4bbb2f76678da9e6abf9fb78281e146b.ogg";